import { render, staticRenderFns } from "./_Dropdown_cp.vue?vue&type=template&id=22bcb4bf&scoped=true&"
import script from "./_Dropdown_cp.vue?vue&type=script&lang=js&"
export * from "./_Dropdown_cp.vue?vue&type=script&lang=js&"
import style0 from "./_Dropdown_cp.vue?vue&type=style&index=0&id=22bcb4bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bcb4bf",
  null
  
)

export default component.exports